import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useRouter } from 'next/router'

import Container, { HomePanel, Row } from 'components/container'
import { SearchBar, SearchListing } from 'components/search'
import Head from 'components/head'

import { withDispatch } from 'store'

const Search = ({ initialSearch = '' }) => {
  const router = useRouter()

  // Check if we've been given a query to search for (?q=<query>).
  // If so, we tell the router to show the URL without that query param
  useEffect(() => {
    const { q = '', ...rest } = router.query
    if (q !== '') {
      const { pathname } = router
      router.replace({ pathname, query: { ...rest } }, null, { shallow: true })
    }
  }, [router])

  return (
    <>
      <Head>
        <title>Search</title>
      </Head>
      <Container>
        <Row>
          <HomePanel>
            <SearchBar initialSearch={initialSearch} />
            <SearchListing />
          </HomePanel>
        </Row>
      </Container>
    </>
  )
}
Search.propTypes = {
  initialSearch: PropTypes.string,
}
Search.getInitialProps = async ({ setHero, fetchSearchPage, fetchMissing, query }) => {
  const { q: initialSearch = '' } = query || {}
  // If we've been given an initial search, we'll query for that data
  if (initialSearch) {
    const [, items] = await fetchSearchPage({ query: initialSearch, category: null })
    await fetchMissing(items)
  }
  setHero({ heading: 'Search', subHeading: 'Search', image: null })
  return {
    initialSearch,
  }
}

export default withDispatch({
  hero: ['setHero'],
  search: ['fetchSearchPage'],
  shared: ['fetchMissing'],
})(Search)
